import { ReducerBuilder } from 'acscp/reducers/reducerBuilder';
import { PushNotificationState } from 'acscp/store/pushNotificationState';
import { UpdateSubscribedPushNotificationChannelsRequest } from 'acscp/api/requests/updateSubscribedPushNotificationChannelsRequest';
import { UpdatePushNotificationChannelSubscriptions } from 'acscp/actions';

export const pushNotificationsReducer =
    new ReducerBuilder<PushNotificationState>({pendingChannelSubscriptionUpdate: false})
        .actionCase(UpdatePushNotificationChannelSubscriptions, state => ({
            ...state,
            pendingChannelSubscriptionUpdate: true
        }))
        .successfulRequestCase(UpdateSubscribedPushNotificationChannelsRequest, state => ({
            ...state,
            pendingChannelSubscriptionUpdate: false
        }))
        .build();
